export default {
    methods: {
        $onePageScroll(page) {
            this.$nextTick(() => {
                const scrollContainer = document.querySelector('.document-view__scroll-container');
                const imgCurrent = document.querySelectorAll('.document-view-multi-page__item')[page - 1];
                scrollContainer.scrollTop = imgCurrent.offsetTop;
            });
        }
    }
};
